module.exports = __webpack_public_path__ + "static/media/photo130.f5a888ab.jpg";